import { mapGetters } from 'vuex'
import { mapState } from 'vuex'

export default {
    data() {
        return {
            allFields: [],
        }
    },
    computed: {
        ...mapState({
            isMinorAccount: (state) =>
                state.registration.form.basicInfo.isMinorAccount,
            addNominee: (state) =>
                state.registration.form.accountInfo.addNominee,
        }),
    },
    watch: {
        isMinorAccount(value) {
            console.log('isminorAccount', value)
            if (value == 'No') {
                this.hideMinorForm()
            } else if (value == 'Yes') {
                this.fields = this.allFields
            }
        },
        addNominee(value) {
            if (value == 'No') {
                this.hideNomineeFields()
                this.$store.commit('updateField', {
                    key: 'accountInfo.nomineeRelationship1Id',
                    value: null,
                })
                this.$store.commit('updateField', {
                    key: 'accountInfo.nomineeRelationship1',
                    value: null,
                })
                this.$store.commit('updateField', {
                    key: 'regAccInfo.relationWithPrinciple',
                    value: null,
                })
            } else if (value == 'Yes') {
                this.fields = this.allFields
            }
        },
    },
    methods: {
        /**
         * Before continuing from setup profile, persist address line 2 when the
         * user chose "same as primary address" (field may have been disabled).
         */
        syncAddress2FromPrimaryWhenSameAsAddress() {
            const ci = this.$store.state.registration.form.contactInfo || {}
            const flag = ci.sameAddress2
            const isYes =
                flag == 'Yes' ||
                flag === true ||
                (typeof flag === 'string' &&
                    flag.trim().toLowerCase() === 'yes')
            if (!isYes) {
                return
            }
            const primary = ci.address == null ? '' : ci.address
            this.$store.commit('updateField', {
                key: 'contactInfo.address2',
                value: primary,
            })
        },
        hideMinorForm() {
            this.fields = this.fields.filter((field, index) => {
                if (
                    field.label == 'Minor Account (if applicable)' ||
                    field.key == 'accountInfo.guardianName' ||
                    field.key == 'accountInfo.guardianRelationship' ||
                    field.key == 'accountInfo.guardianCNIC' ||
                    field.key == 'accountInfo.guardianIssuanceDate' ||
                    field.key == 'accountInfo.guardianExpiryDate' ||
                    field.key == 'accountInfo.guardianMobileNo'
                ) {
                    return false
                }
                return true
            })
        },
        hideNomineeFields() {
            this.fields = this.fields.filter((field, index) => {
                if (
                    field.key == 'accountInfo.nomineeName1' ||
                    field.key == 'accountInfo.nomineeFatherName1' ||
                    field.key == 'accountInfo.nomineeEmail1' ||
                    field.key == 'accountInfo.nomineePhone1' ||
                    field.key == 'accountInfo.nomineeRelationship1' ||
                    field.key == 'accountInfo.nomineeRelationship1Id' ||
                    field.key == 'accountInfo.nomineeCNIC1' ||
                    field.key == 'accountInfo.nomineeAddress1' ||
                    field.key == 'accountInfo.nomineeRelationId1'
                ) {
                    return false
                }
                return true
            })
        },

        lockProvidedIdentityDatesOnFields() {
            if (!this.fields || !this.fields.length) {
                return
            }
            const identity =
                this.$store.state.registration.form.identityInfo || {}
            const basic = this.$store.state.registration.form.basicInfo || {}
            const contact =
                this.$store.state.registration.form.contactInfo || {}
            const fatca = this.$store.state.registration.form.fatcaInfo || {}
            const issue = identity.IssuanceDate
            const dob = basic.dateOfBirth
            const hasIssue =
                issue != null &&
                issue !== '' &&
                !(typeof issue === 'string' && issue.trim() === '')
            const hasDob =
                dob != null &&
                dob !== '' &&
                !(typeof dob === 'string' && dob.trim() === '')
            const hasFirst =
                basic.firstName != null &&
                basic.firstName !== '' &&
                !(
                    typeof basic.firstName === 'string' &&
                    basic.firstName.trim() === ''
                )
            

            this.fields.forEach((field) => {
                if (field.key === 'identityInfo.IssuanceDate' && hasIssue) {
                    this.$set(field, 'isDisabled', true)
                }
                if (field.key === 'basicInfo.dateOfBirth' && hasDob) {
                    this.$set(field, 'isDisabled', true)
                }
                if (field.key === 'basicInfo.firstName' && hasFirst) {
                    this.$set(field, 'isDisabled', true)
                }

            })
        },
    },
}
